/**
 * Created by user on 2019/7/20.
 */

export default `哎
吔
吶喏
嗶哩
啪唧
哞
撒
噫
哦
啊
`.split('\n')
